import { useEffect, useState } from "react";
import { app } from "@microsoft/teams-js";
import { reportTelemetryFailure } from "@/core/telemetry";
import type { TeamsContext } from "@/hooks/useTeamsContext.types";

export const useTeamsContext = (): [TeamsContext] => {
  const [inTeams, setInTeams] = useState<boolean | undefined>(undefined);
  const [theme, setTheme] = useState<string | undefined>(undefined);

  useEffect(() => {
    const detectTeams = async () => {
      const isInIframe = window.self !== window.top;
      const initPromise = app.initialize();
      const racePromise = isInIframe
        ? initPromise
        : Promise.race([
            initPromise,
            new Promise<never>((_, reject) =>
              setTimeout(() => reject(new Error("Teams SDK timeout")), 2000),
            ),
          ]);
      try {
        await racePromise;
        const context = await app.getContext();
        setInTeams(true);
        setTheme(context.app.theme);
      } catch (error) {
        if (isInIframe) {
          reportTelemetryFailure("sdk_init", { reason: String(error) });
        }
        setInTeams(false);
      }
    };
    detectTeams();
  }, []);

  return [{ inTeams, theme }];
};
